
//https://developers.google.com/pay/api/web/reference/request-objects
//https://developers.google.com/pay/api/web/reference/client
//https://developers.google.com/pay/api/web/guides/brand-guidelines
class GooglePayPaymentHelper {
    constructor() {
        this.environment = null; //TEST or PRODUCTION
        this.enabled = false;
        this.gatewayMerchantId = null;
        this.merchantId = null;
        this.merchantName = null;
        this.countryCode = 'GB';
        this.currencyCode = 'GBP';
        this.buttonColor = 'black';
        this.buttonType = 'pay';
        this.buttonSizeMode = 'fill';
        this.pendingTransactionId = null;
        this.paymentIsLocked = false;
        this.baseRequest = {
            apiVersion: 2,
            apiVersionMinor: 0,
            emailRequired: true
        };
        this.baseCardPaymentMethod = {
            type: 'CARD',
            parameters: {
                allowedAuthMethods: ["CRYPTOGRAM_3DS"],
                //allowedAuthMethods: ["CRYPTOGRAM_3DS", "PAN_ONLY"],
                allowedCardNetworks: ["MASTERCARD", "VISA"],
                assuranceDetailsRequired: true,
                billingAddressRequired: true,
                billingAddressParameters: { format: 'FULL' }
            }
        };
        this.paymentsClient = null;
    }
    getGooglePaymentsClient() {
        if (this.paymentsClient === null) {
            let helperInstance = this;
            this.paymentsClient = new google.payments.api.PaymentsClient(
                {
                    environment: this.environment, //DYNAMIC
                    paymentDataCallbacks: {
                        onPaymentAuthorized: function (paymentData) {
                            return helperInstance.onPaymentAuthorized(paymentData);
                        }
                    }
                }
            ); 
        }
        return this.paymentsClient;
    }
    getGoogleIsReadyToPayRequest() {
        return Object.assign(
            {},
            this.baseRequest,
            {
                allowedPaymentMethods: [this.baseCardPaymentMethod]
            }
        );
    }
    onGooglePayLoaded() {
        if (this.enabled) {
            let helperInstance = this;
            const paymentsClient = this.getGooglePaymentsClient();
            paymentsClient.isReadyToPay(this.getGoogleIsReadyToPayRequest())
                .then(function (response) {
                    if (response.result) {
                        const button = helperInstance.createGooglePayButton();
                        helperInstance.onIsReadyToPayResult(true, button);

                        // @todo prefetch payment data to improve performance after confirming site functionality
                        // helperInstance.prefetchGooglePaymentData();
                    }
                    else helperInstance.onIsReadyToPayResult(false, null);
                })
                .catch(function (err) {
                    helperInstance.onError(err, 'GooglePayPaymentHelper/isReadyToPay');
                });
        }
    }
    createGooglePayButton() {
        let helperInstance = this;
        const paymentsClient = this.getGooglePaymentsClient();
        const button =
            paymentsClient.createButton(
                {
                    onClick: function () {
                        helperInstance.onGooglePaymentButtonClicked();
                    },
                    buttonColor: this.buttonColor,
                    buttonType: this.buttonType,
                    buttonSizeMode: this.buttonSizeMode
                }
            );

        return button;
    }
    getCardPaymentMethod() {
        return Object.assign(
            {},
            this.baseCardPaymentMethod,
            {
                tokenizationSpecification: {
                    type: 'PAYMENT_GATEWAY',
                    parameters: {
                        'gateway': 'cybersource',
                        'gatewayMerchantId': this.gatewayMerchantId //DYNAMIC
                    }
                }
            }
        );
    }
    getGooglePaymentDataRequest() {
        const paymentDataRequest = Object.assign({}, this.baseRequest);
        paymentDataRequest.allowedPaymentMethods = [this.getCardPaymentMethod()];
        //paymentDataRequest.transactionInfo = getGoogleTransactionInfo(); //this is done after calling method
        paymentDataRequest.merchantInfo = {
            // @todo a merchant ID is available for a production environment after approval by Google
            // See {@link https://developers.google.com/pay/api/web/guides/test-and-deploy/integration-checklist|Integration checklist}
            merchantId: this.merchantId,
            merchantName: this.merchantName  //DYNAMIC
        };
        paymentDataRequest.callbackIntents = ["PAYMENT_AUTHORIZATION"];

        return paymentDataRequest;
    }
    prefetchGooglePaymentData() {
        const paymentDataRequest = this.getGooglePaymentDataRequest();
        // transactionInfo must be set but does not affect cache
        paymentDataRequest.transactionInfo = { //DYNAMIC
            totalPriceStatus: 'NOT_CURRENTLY_KNOWN',
            currencyCode: this.currencyCode
        };
        const paymentsClient = this.getGooglePaymentsClient();
        paymentsClient.prefetchPaymentData(paymentDataRequest);
    }
    getGoogleTransactionInfo(productData) { //DYNAMIC
 
        if (productData && productData.amountToPay) {
            return {
                countryCode: this.countryCode,
                currencyCode: this.currencyCode,
                totalPriceStatus: 'FINAL',
                // set to cart total
                totalPrice: parseFloat(productData.amountToPay).toFixed(2) //doesnt like 4 trailing zeros
            };
        }
        else return null;

    }
    loadPaymentData(paymentDataRequest) {
        let helperInstance = this;
        const paymentsClient = this.getGooglePaymentsClient();
        paymentsClient.loadPaymentData(paymentDataRequest)
            // no .then(...) processing as onPaymentAuthorized callback has been specified
            .catch(function (err) {
                helperInstance.paymentIsLocked = false;
                if (err && err.statusCode === 'CANCELED') helperInstance.onPaymentCancelled(err);
                else helperInstance.onError(err, 'GooglePayPaymentHelper/loadPaymentData', true);
            });
    }
    onGooglePaymentButtonClicked() {
        try
        {
            if (!this.enabled) return;
            if (this.paymentIsLocked) { return; }

            var productData = this.onProductDataRequested();
            if (!productData) {
                this.onError("Product data missing", "GooglePayPaymentHelper/onGooglePaymentButtonClicked", false, true);
                return;
            }

            this.paymentIsLocked = true;
            this.onPaymentExecuting();

            const paymentDataRequest = this.getGooglePaymentDataRequest();
            paymentDataRequest.transactionInfo = this.getGoogleTransactionInfo(productData);

            if (paymentDataRequest.transactionInfo) {
                this.pendingTransactionId = null;

                if (this.initialiseUrl) {
                    let helperInstance = this;
                    $.ajax({
                        data: JSON.stringify({
                            productId: productData.productId,
                            offerId: productData.offerId,
                            transactionAmount: productData.amountToPay
                        }),
                        type: "POST",
                        contentType: "application/json; charset=utf-8",
                        url: helperInstance.initialiseUrl,
                        dataType: "json",
                        timeout: 60000,
                        success: function (response, textStatus, jqXHR) {
                            if (typeof (fourdHandleAjaxSuccess) != 'undefined') {
                                fourdHandleAjaxSuccess(response, textStatus, jqXHR, this);
                            }
                            var transactionId = null;
                            var responseData = response;
                            if (response && response.d) responseData = response.d;

                            if (responseData) {
                                transactionId = responseData.TransactionId;
                            }

                            if (transactionId != null) {
                                helperInstance.pendingTransactionId = transactionId;
                                paymentDataRequest.transactionInfo.transactionId = transactionId.toString();

                                helperInstance.loadPaymentData(paymentDataRequest);
                            }
                            else {
                                helperInstance.paymentIsLocked = false;
                                helperInstance.onError(helperInstance.initialiseUrl + ' call failed.', helperInstance.initialiseUrl, true);
                            }
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            helperInstance.paymentIsLocked = false;
                            helperInstance.onError(errorThrown, helperInstance.initialiseUrl, true);

                            if (typeof (fourdHandleAjaxError) != 'undefined') {
                                fourdHandleAjaxError(jqXHR, textStatus, errorThrown, this);
                            }
                        }
                    });
                }
                else {
                    this.loadPaymentData(paymentDataRequest);
                }

            }
            else {
                this.paymentIsLocked = false;
                this.onError('TransactionInfo could not be derived', 'GooglePayPaymentHelper/getGoogleTransactionInfo', true);
            }
        }
        catch (err)
        {
            this.paymentIsLocked = false;
            this.onError(err, 'GooglePayPaymentHelper/onGooglePaymentButtonClicked', true);
        }

    }
    onPaymentAuthorized(paymentData) {
        let helperInstance = this;
        return new Promise(function (resolve, reject) {
            try {
                //helperInstance.onPaymentExecuting();
                helperInstance.paymentIsLocked = false; //we have blocking UI overlay confirmed 
                // @todo pass payment token to your gateway to process payment
                var paymentToken = paymentData.paymentMethodData.tokenizationData.token;

                // @todo paymentData.paymentMethodData.info.assuranceDetails will indicate if 3DS is required

                var cardData = {};
                if (paymentData.email) cardData.BillEmail = paymentData.email;
                if (paymentData.paymentMethodData && paymentData.paymentMethodData.info) {
                    if (paymentData.paymentMethodData.info.billingAddress) {
                        if (paymentData.paymentMethodData.info.billingAddress.name) {
                            var fullName = paymentData.paymentMethodData.info.billingAddress.name;
                            cardData.BillLastName = fullName; //space delimited

                            if (fullName.lastIndexOf(' ') > 0) {
                                cardData.BillFirstName = fullName.substring(0, fullName.lastIndexOf(' '));
                                cardData.BillLastName = fullName.substring(fullName.lastIndexOf(' ') + 1);
                            }
                            else {
                                //cardData.BillFirstName = 'N/A';
                            }
                        }

                        cardData.BillStreet1 = paymentData.paymentMethodData.info.billingAddress.address1;
                        cardData.BillStreet2 = paymentData.paymentMethodData.info.billingAddress.address2;
                        cardData.BillCity = paymentData.paymentMethodData.info.billingAddress.locality;
                        cardData.BillState = paymentData.paymentMethodData.info.billingAddress.administrativeArea;
                        cardData.BillCountry = paymentData.paymentMethodData.info.billingAddress.countryCode;
                        //cardData.BillCountryAlpha3Code = paymentData.paymentMethodData.info.billingAddress.countryCode;
                        cardData.BillPostalCode = paymentData.paymentMethodData.info.billingAddress.postalCode;
                    }
                    if (paymentData.paymentMethodData.info.cardDetails) {
                        //last 4 digits of card
                        cardData.CardAccountNumber = 'xxxxxxxxxxxxxxxx'.substring(paymentData.paymentMethodData.info.cardDetails.length)
                            + paymentData.paymentMethodData.info.cardDetails;
                    }
                    if (paymentData.paymentMethodData.info.cardNetwork === 'VISA') {
                        cardData.CardTypeId = 1;
                    }
                    else if (paymentData.paymentMethodData.info.cardNetwork === 'MASTERCARD') {
                        cardData.CardTypeId = 2;
                    }
                }

                var productData = helperInstance.onProductDataRequested();

                $.ajax({
                    data: JSON.stringify({
                        productId: productData.productId,
                        offerId: productData.offerId,
                        transactionAmount: productData.amountToPay,
                        encryptedPaymentData: window.btoa(paymentToken),
                        cardData: cardData,
                        googleResponseData: JSON.stringify(paymentData),
                        transactionId: helperInstance.pendingTransactionId
                    }),
                    type: "POST",
                    contentType: "application/json; charset=utf-8",
                    url: helperInstance.requestPaymentUrl,
                    dataType: "json",
                    timeout: 60000,
                    success: function (response, textStatus, jqXHR) {
                        if (typeof (fourdHandleAjaxSuccess) != 'undefined') {
                            fourdHandleAjaxSuccess(response, textStatus, jqXHR, this);
                        }
                        try {
                            var isAccepted = false;
                            //no longer pending - subsequent attempts should create a new transaction - e.g. trying different card
                            helperInstance.pendingTransactionId = null;
                            var responseData = response;
                            if (response && response.d) responseData = response.d;

                            if (responseData) {
                                isAccepted = responseData.TransactionAccepted;
                            }
                            if (isAccepted) {
                                resolve(
                                    {
                                        transactionState: 'SUCCESS'
                                    }
                                );
                            }
                            else {
                                resolve(
                                    {
                                        transactionState: 'ERROR',
                                        error: {
                                            intent: 'PAYMENT_AUTHORIZATION',
                                            message: 'Payment could not be processed.',
                                            reason: 'PAYMENT_DATA_INVALID'
                                        }
                                    }
                                );
                            }

                            helperInstance.onPaymentExecuted(isAccepted, responseData);
                        }
                        catch (err) {
                            helperInstance.onError(err, 'GooglePayPaymentHelper/onPaymentAuthorized', true);
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        resolve(
                            {
                                transactionState: 'ERROR',
                                error: {
                                    intent: 'PAYMENT_AUTHORIZATION',
                                    message: 'Sorry, an unexpected error occured. Please try again.',
                                    reason: 'OTHER_ERROR'
                                }
                            }
                        );
                        helperInstance.onError(errorThrown, helperInstance.requestPaymentUrl, true);

                        if (typeof (fourdHandleAjaxError) != 'undefined') {
                            fourdHandleAjaxError(jqXHR, textStatus, errorThrown, this);
                        }
                    }
                });

            }
            catch (err) {
                resolve(
                    {
                        transactionState: 'ERROR',
                        error: {
                            intent: 'PAYMENT_AUTHORIZATION',
                            message: 'Sorry, an unexpected error occured. Please try again.',
                            reason: 'OTHER_ERROR'
                        }
                    }
                );
                helperInstance.onError(err, 'GooglePay/processPayment', true);
            }

        });
    }
    initialise(options) {
        var result = false;

        try
        {
            //google.payments.api must have been loaded 
            if (!window.google || !google.payments || !google.payments.api) return result;

            if (!options) options = {};
            if (!options.config) options.config = {};
            if (!options.callbacks) options.callbacks = {};
            if (typeof (FourDConfiguration) !== 'undefined' && FourDConfiguration.endpoints) {
                if (!options.config.initialiseUrl && typeof (FourDConfiguration.endpoints.googlePayInitialisePayment) == 'string') options.config.initialiseUrl = FourDConfiguration.endpoints.googlePayInitialisePayment;
                if (!options.config.requestPaymentUrl && typeof (FourDConfiguration.endpoints.googlePayRequestPayment) == 'string') options.config.requestPaymentUrl = FourDConfiguration.endpoints.googlePayRequestPayment;
            }

            if (options.config
                && options.config.environment
                && options.config.gatewayMerchantId
                && options.config.requestPaymentUrl
            ) {
                this.environment = options.config.environment;
                this.gatewayMerchantId = options.config.gatewayMerchantId;
                this.merchantId = options.config.merchantId;
                this.merchantName = options.config.merchantName;
                this.requestPaymentUrl = options.config.requestPaymentUrl;
                if (options.config.initialiseUrl) this.initialiseUrl = options.config.initialiseUrl;
                if (options.config.countryCode) this.countryCode = options.config.countryCode;
                if (options.config.currencyCode) this.currencyCode = options.config.currencyCode;
                if (options.config.buttonColor) this.buttonColor = options.config.buttonColor;
                if (options.config.buttonType) this.buttonType = options.config.buttonType;
                if (options.config.buttonSizeMode) this.buttonSizeMode = options.config.buttonSizeMode;

                if (options.callbacks
                    && options.callbacks.onProductDataRequested
                ) {
                    if (typeof (options.callbacks.onProductDataRequested) == 'function') this.onProductDataRequested = options.callbacks.onProductDataRequested;
                    if (typeof (options.callbacks.onIsReadyToPayResult) == 'function') this.onIsReadyToPayResult = options.callbacks.onIsReadyToPayResult;
                    if (typeof (options.callbacks.onError) == 'function') this.onError = options.callbacks.onError;
                    if (typeof (options.callbacks.onPaymentExecuting) == 'function') this.onPaymentExecuting = options.callbacks.onPaymentExecuting;
                    if (typeof (options.callbacks.onPaymentCancelled) == 'function') this.onPaymentCancelled = options.callbacks.onPaymentCancelled;
                    if (typeof (options.callbacks.onPaymentExecuted) == 'function') this.onPaymentExecuted = options.callbacks.onPaymentExecuted;

                    result = true;
                    this.enabled = true;

                    this.onGooglePayLoaded();
                }
            }
        }
        catch (err) {
            this.onError(err, 'GooglePayPaymentHelper/initialise');
        }
        return result;
    }
    onProductDataRequested() { return null; }
    onIsReadyToPayResult(isAccepted, buttonHtml) {}
    onError(err, stageText, wasPaymentExecuting, wasProductMissing) {}
    onPaymentExecuting() { }
    onPaymentCancelled(err) {}
    onPaymentExecuted(isAccepted, responseData) {}
};

const GooglePayPayment = new GooglePayPaymentHelper();